module.exports = "<pre><code class=\"lang-html\">&lt;v-stepper ref=&quot;stepper&quot; :steps=&quot;steps&quot; v-model=&quot;step&quot;&gt;&lt;/v-stepper&gt;\n\n&lt;!-- Stepper Controls --&gt;\n&lt;button type=&quot;button&quot; @click=&quot;$refs.stepper.previous()&quot;&gt;Previous&lt;/button&gt;\n&lt;button type=&quot;button&quot; @click=&quot;$refs.stepper.next()&quot;&gt;Next&lt;/button&gt;\n&lt;button type=&quot;button&quot; @click=&quot;$refs.stepper.reset()&quot;&gt;Reset&lt;/button&gt;\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./src/markdowns/examples/programmatic/template.md
// module id = 3wBu
// module chunks = 1